/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProcessedSubscriptionResponse { 
    org_id?: string;
    charge_id?: string;
    created_ts?: Date;
    datacenter?: string;
    from_ts?: Date;
    quantity?: number;
    to_ts?: Date;
    updated_ts?: Date;
    id?: number;
}

